"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpQuery = exports.QUERY_LIST_TYPE = void 0;
var QUERY_LIST_TYPE;
(function (QUERY_LIST_TYPE) {
    QUERY_LIST_TYPE["multiple"] = "multiple";
    QUERY_LIST_TYPE["join"] = "join";
})(QUERY_LIST_TYPE = exports.QUERY_LIST_TYPE || (exports.QUERY_LIST_TYPE = {}));
class HttpQuery {
    constructor(queryBuilder, config) {
        this.queryBuilder = queryBuilder;
        this.config = config;
    }
    toString(payload) {
        const params = this.queryBuilder(payload);
        return Object.keys(params)
            .reduce((acc, key) => {
            var _a;
            const value = params[key];
            if (value === undefined) {
                return acc;
            }
            if (Array.isArray(value) && ((_a = this.config) === null || _a === void 0 ? void 0 : _a.listType) === QUERY_LIST_TYPE.multiple) {
                value
                    .filter((v) => v !== undefined)
                    .forEach((v) => {
                    acc += `&${key}=${encodeURIComponent(String(v))}`;
                });
                return acc;
            }
            acc += `&${key}=${encodeURIComponent(String(value))}`;
            return acc;
        }, '')
            .replace(/^&+/, '');
    }
}
exports.HttpQuery = HttpQuery;
//# sourceMappingURL=HttpQuery.js.map